import isDate from "lodash/isDate";
import { TimePickerValue } from "react-time-picker";
import CollabDocCatchUpDetails from "../types/catch-ups/CollabDocCatchUpDetails";
import MeetingFormFields from "../types/catch-ups/MeetingFormFields";
import { UsageScenario } from "../types/generic/UsageScenario";
import dateHelper from "./dateHelper";

class CatchUpValidator {
  constructor(subjectFieldRequired: boolean) {
    this.subjectFieldRequired = subjectFieldRequired;
  }

  subjectFieldRequired: boolean;

  dateFieldIsValid = (dateValue: Date | undefined) => {
    return dateValue !== undefined && isDate(dateValue);
  };

  timeFieldIsValid = (timeValue: string | TimePickerValue | undefined) => {
    return timeValue !== undefined && dateHelper.timeIsValid(timeValue);
  };

  subjectFieldIsValid = (selectedClientFormId: number | undefined) => {
    if (!this.subjectFieldRequired) return true;
    return (
      selectedClientFormId !== undefined &&
      !isNaN(selectedClientFormId) &&
      selectedClientFormId > 0
    );
  };

  subjectUserFieldIsValid = (userId: number | undefined) => {
    return userId !== undefined && !isNaN(userId) && userId > 0;
  };

  participantFieldIsValid = (selectedParticipantId: number | undefined) => {
    return (
      selectedParticipantId !== undefined &&
      !isNaN(selectedParticipantId) &&
      selectedParticipantId > 0
    );
  };

  timingPreferenceIsValid = (
    timingPreference: "NOW" | "FUTURE" | undefined,
  ) => {
    return timingPreference === "NOW" || timingPreference === "FUTURE";
  };

  answerSetGuidIdIsValid = (answerSetGuidId: string | undefined) => {
    return answerSetGuidId !== undefined;
  };

  isValidCollabDocCatchUp = (
    scheduledDate: Date | undefined,
    catchUpDetails: CollabDocCatchUpDetails,
  ) => {
    return (
      this.dateFieldIsValid(scheduledDate) &&
      this.participantFieldIsValid(catchUpDetails.participantEmployeeId) &&
      this.subjectUserFieldIsValid(catchUpDetails.subjectUserId) &&
      this.answerSetGuidIdIsValid(catchUpDetails.answerSetUniqueId)
    );
  };

  isFullyValid = (
    formFieldValues: MeetingFormFields,
    usageScenario: UsageScenario,
  ) => {
    // Basic validation - common required fields
    const basicValidation =
      this.subjectFieldIsValid(formFieldValues.subjectClientFormId) &&
      this.participantFieldIsValid(formFieldValues.otherParticipantId) &&
      this.subjectUserFieldIsValid(formFieldValues.subjectUserId);

    // Use different validation logic based on usage scenario
    if (usageScenario === "DASHBOARD") {
      // Dashboard requires timing preference
      if (!this.timingPreferenceIsValid(formFieldValues.timingPreference)) {
        return false;
      }

      // If "Schedule for Later" is selected, validate date
      if (formFieldValues.timingPreference === "FUTURE") {
        return (
          basicValidation && this.dateFieldIsValid(formFieldValues.targetDate)
        );
      }

      // Immediate catch-up doesn't need date validation
      return basicValidation;
    } else {
      // Journey/Collab Doc always requires a valid date
      return (
        basicValidation && this.dateFieldIsValid(formFieldValues.targetDate)
      );
    }
  };
}

export default CatchUpValidator;
